import { Button, makeStyles } from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterList";
import { useTranslate } from "react-admin";
const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: theme.orange,
    borderRadius: 18,
    width: 110,
    minHeight: 35,
    height: 35,
    fontSize: 14,
    color: theme.white,
  },
  icon: {
    width: 20,
    height: 20,
    color: theme.white,
  },
}));
const FilterMemberButton = ({ onClick }) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Button
      variant="contained"
      onClick={onClick}
      className={classes.button}
      startIcon={<FilterIcon className={classes.icon} />}
    >
      {translate("ra.text.ci.filter")}
    </Button>
  );
};
export default FilterMemberButton;
